const init = () => {
    var $component = $('.c-book-block-list');
    if (!$component.length) return;

    // Handle image loading with CLS prevention
    initImageLoading();
    
    // Handle audiobook-specific styling
    handleAudiobookStyling();

    // Run immediately and on window resize
    run();
    $(window).on('resize', _.debounce(run, 250));

    function run() {
        var $contents = $component.find('.c-book-block-list__content');
        switch(im.getActive()) {
            case 'phone':
                var chunks = _.chunk($contents, 2);
            break;
            case 'tablet':
                var chunks = _.chunk($contents, 4);
            break;
            default:
                var chunks = _.chunk($contents, 6);
            break;
        }
        _.each(chunks, function(chunk) {
            setContentHeight($(chunk));
        });
    }

    function setContentHeight($content) {
        var maxHeight = Math.max.apply(null, $content.map(function() {
            return $(this).height();
        }).get());
        $content.height(maxHeight);
    }

    function initImageLoading() {
        // Handle image loading with CLS prevention
        const images = $component.find('img');
        images.each(function() {
            const $img = $(this);
            const $container = $img.closest('.c-book-block-list__thumb');
            
            if ($img[0].complete) {
                $img.addClass('loaded');
                $container.addClass('image-loaded');
            } else {
                $img.on('load', function() {
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                });
                $img.on('error', function() {
                    // Still fade in on error to prevent infinite loading state
                    $img.addClass('loaded');
                    $container.addClass('image-loaded');
                });
            }
        });
    }
    
    function handleAudiobookStyling() {
        // Check if the title contains 'audiobooks' (case insensitive)
        const $title = $component.find('.c-title-bar__title');
        if ($title.length && $title.text().toLowerCase().includes('audiobooks')) {
            // Set min-height for audiobook thumbnails
            $component.find('.c-book-block-list__thumb').css('min-height', '160px');
        }
    }

    // Expose run function for external calls (e.g., from load-more)
    window.app = window.app || {};
    window.app.bookBlockList = window.app.bookBlockList || {};
    window.app.bookBlockList.run = run;
    window.app.bookBlockList.initImageLoading = initImageLoading;

}

export default init;